import { EnvironmentDetailsHeader } from "@/components/environments/EnvironmentDetailsHeader";
import { EnvironmentTaskRuns } from "@/components/environments/EnvironmentTaskRuns";

import { useEnvironmentDetailsOutletContext } from "@/hooks/use-environment-details-outlet-context";
import { type FC } from "react";
import { useParams } from "react-router-dom";

export const EnvironmentTaskRunsPage: FC = () => {
    // Title is handled by EnvironmentDetailsLayout using dynamic title

    const { environmentId, taskId } = useParams();
    const outletContext = useEnvironmentDetailsOutletContext();
    const showingAgentConversation = outletContext?.showingAgentConversation ?? false;

    return (
        <div className="flex size-full flex-col gap-4">
            {environmentId && (
                <>
                    <div className="flex flex-col gap-4">
                        {!showingAgentConversation && <EnvironmentDetailsHeader showActionBar={false} />}
                    </div>
                    <EnvironmentTaskRuns environmentId={environmentId} taskId={taskId} />
                </>
            )}
        </div>
    );
};
